var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdyenMerchantPanel',{attrs:{"title-key":"smoothrPay.payments.title","subtitle-key":"smoothrPay.payments.subtitle","select-merchant-key":"smoothrPay.payments.selectMerchant","component":_vm.transactionsOverview}})
}
var staticRenderFns = []

export { render, staticRenderFns }